import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { account_type_translations } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";


const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "12px",
    border: "none"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: "#0b1f82",
    fontSize: "20px",
    lineHeight: "30px",
    padding: "14px",
  },
}));

function AccountResumeTable(props) {
  const classes = useStyles();
  useTheme();

  const { account } = props

  const { t } = useTranslation()
  
  const { account_type, not_listed } = account_type_translations

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>{t("account_type")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("agency")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("account")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("people_linked")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("devices_registered")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("registration_date")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={"odd"}>
            <TableCell className={classes.tableText}>
              <Tooltip title={<p className="tooltipText">{account_type[account.account_type] ? t(account_type[account.account_type].description) : t(account.account_type)}</p>}>
                <div className={["circle", "small"].join(" ")} style={{backgroundColor: (account_type[account.account_type] || not_listed).color }}>
                  {t((account_type[account.account_type] || not_listed).siglum)}
                </div>
              </Tooltip>
            </TableCell>
            <TableCell className={classes.tableText}>
                <div>
                  {account.account_data?.agency_number ?? t("not_informed")}
                </div>
            </TableCell>
            <TableCell className={classes.tableText}>
              <div>
                {account.account_data?.account_number ?? t("not_informed")}
              </div>
            </TableCell>
            <TableCell className={classes.tableText}>
              <div>
                {account.persons.length}
              </div>
            </TableCell>
            <TableCell className={classes.tableText}>
              <div>
                {account.persons.reduce((sum, person) => {
                  const registeredDevices = person.devices.filter(device => device.status === "registered");
                  return sum + registeredDevices.length;
                }, 0)}
              </div>
            </TableCell>
            <TableCell className={classes.tableText}>
              {moment(account.registration_date).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}
export default AccountResumeTable;
